import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import HomepageFooter from './HomepageFooter';
import { LazyImage, Link, PageTitle } from '~COMPONENTS/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';
import { LanguageUpdateCheck } from '../../static';
import HomePageCarousel from './HomePageCarousel';

import { deepLinkInfoLoading, getUserData, getUserAccount } from '../selectors';
import { hasAuthCheckFinished } from '../../auth/reducer';
import { getSelectedDepartment } from '../../shop/selectors';
import { getIsShoppingEnabled } from '../../gamedayAccount/selectors';

import { userTypes, userAccountTypes } from '../../types/user';

import SmallBackgroundImage from '~IMAGES/homepage-background-mobile.jpg';
import LargeBackgroundImage from '~IMAGES/homepage-background-desktop.jpg';

export const HomePage = ({ deepLinkInfoLoading, userAccount, user, isShoppingEnabled }) => {
  const windowSize = window && window.outerWidth;
  const isInvoiceOnly = user && user.role === 'GAMEDAY_INVOICE_ONLY';
  if (deepLinkInfoLoading) {
    return null;
  }

  return !(user && user?.accountDepartments.length) ? (
    <Redirect to={{ pathname: '/select-accounts' }} />
  ) : (
    <div className='homepage bg-primary-grey'>
      <PageTitle title='login.welcome' />
      <LazyImage
        src={windowSize && windowSize < 600 ? SmallBackgroundImage : LargeBackgroundImage}
        alt='locker room'
        className='homepage__bg'
        data-desc='homepage__image_bg'
      />
      <div className='homepage__content'>
        <div className='homepage__wrapper bg-black'>
          <div className='homepage__header pt12-sm prl7-sm prl0-md text-color-primary-light'>
            <div className='homepage__header_title responsive-display-2-1'>
              <TranslatedCopy id='homepage.headline' />
            </div>
            <div className='pt3-sm'>
              <TranslatedCopy id='login.welcome' />
            </div>
          </div>
          <div className='homepage__main_wrap bg-white mrl7-md'>
            <div className='homepage__main_header pt10-sm pb10-sm prl7-sm p12-md'>
              <div>
                {user && (
                  <div className='homepage__main_header__name headline-1'>
                    <TranslatedCopy id='homepage.hello' values={{ name: user.firstName }} />
                  </div>
                )}
                {
                  <div className='headline-5'>
                    {userAccount.number} {userAccount.name}
                  </div>
                }
              </div>
              {!isInvoiceOnly &&
                (isShoppingEnabled ? (
                  <Link to='/shop' button className='homepage__main_shop mt10-sm mt0-md'>
                    <TranslatedCopy id='global.shop' />
                  </Link>
                ) : (
                  <Link to='/' button disabled className='homepage__main_shop mt10-sm mt0-md'>
                    <TranslatedCopy id='global.shop' />
                  </Link>
                ))}
            </div>
            <div className='homepage__main p7-sm prl12-md'>
              <HomePageCarousel />
            </div>
          </div>
        </div>
        <div>
          <LanguageUpdateCheck />
          <HomepageFooter user={user} />
        </div>
      </div>
    </div>
  );
};

HomePage.propTypes = {
  deepLinkInfoLoading: PropTypes.bool.isRequired,
  user: userTypes,
  userAccount: userAccountTypes,
  isShoppingEnabled: PropTypes.bool.isRequired
};

HomePage.defaultProps = {
  user: null,
  userAccount: null
};

const mapStateToProps = state => ({
  deepLinkInfoLoading: deepLinkInfoLoading(state),
  hasAuthCheckFinished: hasAuthCheckFinished(state),
  selectedDepartment: getSelectedDepartment(state),
  user: getUserData(state),
  userAccount: getUserAccount(state),
  isShoppingEnabled: getIsShoppingEnabled(state)
});

const connector = connect(mapStateToProps, {});

export default connector(HomePage);
